import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.string.link";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import classNames from 'classnames';
import Type from '@nerdwallet/react-typography';
import styles from './simple-link.module.less';

var inferType = function inferType(Component) {
  // Should use type=button when using a `<button>` component, but not needed
  // when using `<a>`. This can be overridden by passing a `type` prop.
  if (Component === 'button') {
    return {
      type: 'button'
    };
  }

  return {};
};
/**
 * `<Link>` will inherit font family and size if none are specified. For
 * example, no `size` prop is needed here:
 *
 *  <Body size="small">
 *    <Link href="#">Click</Link>
 *  </Body>
 *
 * Size can be customized with the size prop. If possible, prefer the semantic
 * `small` and `legal` sizes:
 *
 *   <Link size="small" />
 *   <Link size="legal" />
 *
 * However, if needed, numeric sizes in the range [0, 5] can be used instead.
 * See `@nerdwallet/react-typography` for more implementation details on these
 * sizes.
 */


var validSizes = [0, 1, 2, 3, 4, 5];
var linkLevelSizeMap = {
  small: 1,
  legal: '0'
};
var SimpleLink = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _classNames;

  var children = props.children,
      className = props.className,
      component = props.component,
      href = props.href,
      size = props.size,
      dangerouslyForceHoverStyling = props.dangerouslyForceHoverStyling,
      dangerouslyForceFocusStyling = props.dangerouslyForceFocusStyling,
      dangerouslyForceActiveStyling = props.dangerouslyForceActiveStyling,
      disabled = props.disabled,
      gotham = props.gotham,
      otherProps = _objectWithoutProperties(props, ["children", "className", "component", "href", "size", "dangerouslyForceHoverStyling", "dangerouslyForceFocusStyling", "dangerouslyForceActiveStyling", "disabled", "gotham"]); // Component overrides


  var Component = component || (href ? 'a' : 'button');
  return /*#__PURE__*/React.createElement(Type, _extends({}, inferType(Component), {
    className: classNames(className, styles.link, (_classNames = {}, _defineProperty(_classNames, styles['button-unstyling'], Component === 'button'), _defineProperty(_classNames, styles['type-font-size-inherit'], size == null), _defineProperty(_classNames, styles.disabled, disabled), _defineProperty(_classNames, styles['force-active'], dangerouslyForceActiveStyling), _defineProperty(_classNames, styles['force-focus'], dangerouslyForceFocusStyling), _defineProperty(_classNames, styles['force-hover'], dangerouslyForceHoverStyling), _defineProperty(_classNames, styles['font-family-inherit'], !gotham), _classNames)),
    component: Component // Don't render this prop to the DOM unless we're actually disabled
    ,
    disabled: disabled || undefined,
    href: href,
    ref: ref // Get the numeric size if a semantic
    // size prop is used (eg. "small")
    ,
    size: linkLevelSizeMap[size] || size,
    gotham: gotham
  }, otherProps), children);
});
SimpleLink.displayName = 'SimpleLink';
export default SimpleLink;